import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AuthService } from 'app/store/services/auth.service';
import { getIsAuthenticated } from 'app/store/selectors/user.selector';
import { loginFailed } from 'app/store/actions/user.action';
import { IReducers } from 'app/store/reducers';

@Component({
  selector: 'app-spacescout-callback',
  template: '<p>Signing in…</p>',
})
export class SpacescoutCallbackComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private store: Store<IReducers>,
    private actions$: Actions,
  ) {}

  ngOnInit(): void {
    this.store
      .select(getIsAuthenticated)
      .pipe(takeUntil(this.destroy$))
      .subscribe((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          localStorage.setItem('comming_from', 'login');
          this.router.navigate(['/messages']);
        }
      });

    this.actions$
      .pipe(ofType(loginFailed), take(1), takeUntil(this.destroy$))
      .subscribe(() => {
        this.router.navigate(['/login']);
      });

    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const savedState = sessionStorage.getItem('sso_state');
    const codeVerifier = sessionStorage.getItem('sso_code_verifier');

    sessionStorage.removeItem('sso_state');
    sessionStorage.removeItem('sso_code_verifier');

    if (!code || !state || state !== savedState) {
      this.router.navigate(['/login']);
      return;
    }

    this.authService.loginWithSso('spacescout', {
      code,
      code_verifier: codeVerifier || '',
      redirect_uri: window.location.origin + '/auth/spacescout/callback',
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
